// src/contexts/MyProvider.js
import React, { createContext, useEffect, useRef, useState } from "react";

import SidebarContext from "./MyContext";
import { fetchAndActivate, getValue } from "firebase/remote-config";
import { remoteConfig } from "../config/firebaseConfig";
import { useNavigate } from "react-router-dom";
import LoginModal from "../pages/login/login";
import { AudioHandler } from "../Apihander/AudioRecording/AudioRecording";
import { successToast, errorToast } from "../utils/notificationUtils";
import { syncExistingPushToken, onForegroundMessage, showBackgroundNotification } from "../utils/pushNotification";
import { formatTimeInHHMMSS } from "../utils/timeFile";


const MyProvider = ({ children }) => {
    const initialTabIndex = localStorage.getItem("tabIndex") || 1;

    const [tabIndex, setTabIndex] = useState(initialTabIndex);
    // console.log("🚀 ~ MyProvider ~ tabIndex:", tabIndex)
    const [audio, setAudio] = useState();
    // console.log("🚀 ~ MyProvider ~-------------- audio:", audio)
    const [selectMergeAudio, setSelectMergeAudio] = useState([]);
    const [selectedConvertAudio, setSelectedConvertAudio] = useState([]);
    const [selectedTranscriptAudio, setSelectedTranscriptAudio] = useState([]);
    const [selectedTrimAudio, setSelectedTrimAudio] = useState([]);
    const [selectedAdjustAudio, setSelectedAdjustAudio] = useState([]);
    const [audioData, setAudioData] = useState([]);
    const [selectedFormat, setSelectedFormat] = useState("");
    const [selectedQuality, setSelectedQuality] = useState("");
    const [audioIndex, setAudioIndex] = useState(0);
    // True while the selected audio is actually playing, so lists can flag the active row.
    const [isAudioPlaying, setIsAudioPlaying] = useState(false);
    const [user, setUser] = useState(null);
    const [userAccountEmail, setUserAccountEmail] = useState(null);
    const [clickedAudios, setClickedAudios] = useState(new Set());
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [audioReName, setAudioReName] = useState("");
    const [initialAudioName, setInitialAudioName] = useState('')
    const [folderAudioData, setFolderAudioData] = useState([]);
    const [folderAudioIndex, setFolderAudioIndex] = useState(0);
    const [openForgotPasswordModal, setOpenForgotPasswordModal] = useState(false);
    const [openOtpModal, setOpenOtpModal] = useState(false)
    const [storeOtpUser, setStoreOtpUser] = useState()
    const [folderAudioDataForIndex, setFolderAudioDataForIndex] = useState([])
    const [folders, setFolders] = useState([]);
    const [selectedAudioId, setSelectedAudioId] = useState(null);
    const [textAreaContent, setTextAreaContent] = useState('');
    const [isUpdateTranscribe, setIsUpdateTranscribe] = useState(false);
    const [openFolderCreateModal, setOpenFolderCreateModal] = useState(false);
    const [noFolderAudioData, setNoFolderAudioData] = useState([]);
    const [filterAudioData, setFilterAudioData] = useState([])
    const [favoriteAudio, setFavoriteAudio] = useState([]);
    const [currentAudioId, setCurrentAudioId] = useState(null);
    const [selectedFolderAudioId, setSelectedFolderAudioId] = useState(null);
    const [listTabIndex, setListTabIndex] = useState(1);
    const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false); // State to track dropdown visibility
    const [actionTabIndex, setActionTabIndex] = useState(null);
    const [recordNew, setRecordNew] = useState(false);
    const [isPremium, setIsPremium] = useState(false);
    const [premiumLoading, setPremiumLoading] = useState(false);
    const [premiumStatus, setPremiumStatus] = useState(null);
    const [premiumStatusLoading, setPremiumStatusLoading] = useState(false);
    const [isPolling, setIsPolling] = useState(false);
    const [isAnnual, setIsAnnual] = useState(true);
    const [isProductionMode, setIsProductionMode] = useState(false);
    const [webPlanDetails, setWebPlanDetails] = useState()
    const [managePlanDetails, setManagePlanDetails] = useState()
    const [isWebUser, setIsWebUser] = useState(false);
    const [isRecordingStarted, setIsRecordingStarted] = useState(false);
    const [isLoginCancel, setIsLoginCancel] = useState(false)
    const [isMicrophoneAvailable, setIsMicrophoneAvailable] = useState(false);
    const [widgetLoaded, setWidgetLoaded] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const [actionType, setActionType] = useState("");  // Track the action type ('next' or 'prev')
    const [pendingIndex, setPendingIndex] = useState(null); // Store the next index when modal opens
    const [userReviews, setUserReviews] = useState([])
    const [isRecording, setIsRecording] = useState(false);
    // Ids of audios whose start request is still in flight, so switching audio keeps each spinner.
    const [transcribeStartingIds, setTranscribeStartingIds] = useState([]);
    // Ids of audios whose transcription job is still running, so one job is started per audio.
    const [transcribeInProgressIds, setTranscribeInProgressIds] = useState([]);
    // Id of a recording handed over from AI Tools, so the player can select it after the tab switch.
    const [handoffAudioId, setHandoffAudioId] = useState(null);
    // Set by the AI Tools note card, so the record screen starts recording on its own.
    const [autoStartRecording, setAutoStartRecording] = useState(false);
    // Folder the Start Recording button was clicked in, so the recording is saved there.
    const [recordingFolderId, setRecordingFolderId] = useState(null);
    // Text file handed over from AI Tools, so the translate screen has something to work on.
    const [translateSource, setTranslateSource] = useState(null);
    // AI Tools card that is currently working ("tts", "extract", "transcribe"...), kept here so a running job survives the tab switch that unmounts that screen.
    const [aiToolBusy, setAiToolBusy] = useState(null);
    const [isSubscriptionActive, setIsSubscriptionActive] = useState(false);
    const [audioBlobUrl, setAudioBlobUrl] = useState(null);
    // A recording finished while logged out, held until the visitor authenticates.
    const [pendingGuestRecording, setPendingGuestRecording] = useState(null);
    const pendingGuestUploadRef = useRef(null);
    // Bumped whenever a recording is added outside the dashboard, so its list refetches.
    const [audioListRefreshKey, setAudioListRefreshKey] = useState(0);
    const [alertModal, setAlertModal] = useState(false)
    const [eventClick, setEventClick] = useState(null)




    const [elapsedTime, setElapsedTime] = useState(0);
    const mediaRecorderRef = useRef(null);
    const shouldUploadRef = useRef(true);
    const mediaStreamRef = useRef(null);
    const elapsedTimeRef = useRef(0);
    const intervalRef = useRef(null);
    const sectionRef = useRef(null);  // Create a ref for the target section



    const [recordingStart, setRecordingStart] = useState(false);
    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [btntoggl, setBtnToggl] = useState(false)
    const navigate = useNavigate();
    const [lastType, setLastType] = useState(null);







    // console.log("🚀 ~ MyProvider ~ user:", user)

    useEffect(() => {
        localStorage.setItem("tabIndex", tabIndex);
    }, [tabIndex, audio]);


    useEffect(() => {
        const userData = localStorage.getItem("currentUser");

        const convertedUserData = JSON.parse(userData)
        if (userData) {
            setUser(JSON.parse(userData));
            setUserAccountEmail(convertedUserData?.email)
        }
    }, []);
    // useEffect(() => {
    //     const unloadCallback = (event) => {
    //         event.preventDefault();
    //         event.returnValue = "";
    //         return "";
    //     };

    //     window.addEventListener("beforeunload", unloadCallback);
    //     return () => window.removeEventListener("beforeunload", unloadCallback);
    // }, []);



    const storeUser = (user) => {
        localStorage.setItem("currentUser", user);

        const convertedUserData = JSON.parse(user)

        setUser(JSON.parse(user));
        setUserAccountEmail(convertedUserData?.email)

    };



    const fetchRemoteConfig = async () => {
        try {
            const activated = await fetchAndActivate(remoteConfig);
            if (activated) {
                console.log("Remote config fetched and activated.");
            } else {
                console.log("Remote config fetched but not activated.");
            }

            const configResponseOfPlanDetails = getValue(remoteConfig, "web_plan_details").asString();
            // console.log("configResponse:", configResponseOfPlanDetails);
            const parsedConfig = JSON.parse(configResponseOfPlanDetails);

            // Set web plan details and production mode
            setWebPlanDetails(parsedConfig);
            setIsProductionMode(parsedConfig?.is_production_mode);

            const configResponseOfManagePlan = getValue(remoteConfig, "check_plan_id_web").asString()
            const parsedConfigOfPlanDetails = JSON.parse(configResponseOfManagePlan);
            // console.log(parsedConfigOfPlanDetails, 'parsedConfigOfPlanDetails')
            setManagePlanDetails(parsedConfigOfPlanDetails)

            const configResponseOfUserReview = getValue(remoteConfig, "user_review_web").asString()
            setUserReviews(JSON.parse(configResponseOfUserReview))



        } catch (error) {
            console.error("Failed to fetch remote config:", error);
        }
    };


    useEffect(() => {
        fetchRemoteConfig();
    }, []);


    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem("currentUser"));
        if (storedUser?.isSubscriptionActive) {
            setIsSubscriptionActive(true);
        }
    }, []);


    // Tab index change to state vlaue remove

    useEffect(() => {
        if (tabIndex == 1) {
            setAudio("");
            setSelectMergeAudio([]);
            setSelectedConvertAudio([]);
            setSelectedTranscriptAudio([]);
            setSelectedTrimAudio([]);
            setSelectedAdjustAudio([]);
            setSelectedAudioId('')
        } else if (tabIndex === 2) {
            setSelectMergeAudio([]);
            setSelectedConvertAudio([]);
            setSelectedTranscriptAudio([]);
            setSelectedTrimAudio([]);
            // A recording handed over from AI Tools arrives selected, so its selection is left alone.
            if (!handoffAudioId) {
                setSelectedAudioId('')
                setAudioIndex("")
            }
            setSelectedAdjustAudio([]);
        } else if (actionTabIndex === 3) {
            setAudio("");
            setSelectMergeAudio([]);
            setSelectedConvertAudio([]);
            setSelectedTranscriptAudio([]);
            // setSelectedTrimAudio([]);
            setSelectedAudioId('')
        } else if (actionTabIndex === 4) {
            setAudio("");
            setSelectedTrimAudio([]);
            setSelectedConvertAudio([]);
            setSelectedTranscriptAudio([]);
        } else if (actionTabIndex === 5) {
            setAudio("");
            setSelectedTrimAudio([]);
            setSelectedTranscriptAudio([]);
            setSelectMergeAudio([]);
            setSelectedAudioId('')

            // setSelectedConvertAudio([]);

        } else if (actionTabIndex === 6) {
            setAudio("");
            setSelectedTrimAudio([]);
            // setSelectedTranscriptAudio([]);
            setSelectedConvertAudio([]);
            setSelectMergeAudio([]);
            setSelectedAudioId('')


        } else if (actionTabIndex === 7) {
            setAudio("");
            setSelectedTrimAudio([]);
            setSelectedTranscriptAudio([]);
            setSelectedConvertAudio([]);
            setSelectMergeAudio([]);
            setSelectedAudioId('')
        }
    }, [tabIndex]);

    const resetRecording = () => {

        if (mediaRecorderRef.current) {
            shouldUploadRef.current = false; // Prevent upload on reset
            mediaRecorderRef.current.stop(); // Triggers the `onstop` event
            mediaRecorderRef.current = null; // Clear the MediaRecorder
        }

        if (mediaStreamRef.current) {
            mediaStreamRef.current.getTracks().forEach((track) => track.stop());
            mediaStreamRef.current = null; // Clear the MediaStream
        }

        setIsRecording(false);
        clearInterval(intervalRef.current); // Stop the timer
        setElapsedTime(0); // Reset the elapsed time
        elapsedTimeRef.current = 0; // Reset the reference for elapsed time
    };


    const stopRecording = () => {
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            setIsRecording(false);
            clearInterval(intervalRef.current);
            setElapsedTime(elapsedTimeRef.current);

        }
    };

    const pauseRecording = () => {
        if (mediaRecorderRef.current) {
            if (mediaRecorderRef.current.state === 'recording') {
                mediaRecorderRef.current.pause();
                setIsPaused(true);
                clearInterval(intervalRef.current);
                // console.log('Recording paused...');
            } else if (mediaRecorderRef.current.state === 'paused') {
                mediaRecorderRef.current.resume();
                setIsPaused(false);
                intervalRef.current = setInterval(() => {
                    elapsedTimeRef.current += 1;
                    setElapsedTime(elapsedTimeRef.current);
                }, 1000);
                // console.log('Recording resumed...');
            }
        }
    };

    const loginOpenModal = () => {
        setLoginModalOpen(true);
        pauseRecording()


    };
    const loginCloseModal = () => {
        setLoginModalOpen(false);

    }
    const loginPremiumCloseModal = () => {
        setLoginModalOpen(false);

    };

    const handleSaveAudioRecording = (() => {
        // Create a closure to track the last event type
        let lastEventType = null;

        // Return the actual handler function
        return (type) => {


            // Update the last event type
            lastEventType = type;

            if (user) {
                setRecordingStart(true);
                stopRecording();
                setIsLoginCancel(false);
            } else if (type == "isPricing") {
                // navigate("/pricing");
                setRecordingStart(true);
                stopRecording();
                setIsLoginCancel(true);
                setBtnToggl(false);
            }
            else if (type == "isLogin") {
                loginOpenModal();
                setIsLoginCancel(true);
                setBtnToggl(false);
            }
            else if (type == "isSignup") {
                // loginOpenModal();
                stopRecording();

                setIsLoginCancel(true);
                setBtnToggl(false);
            }
            else {
                loginOpenModal();
            }
        };
    })();

    // A recording made before login belongs to whoever authenticates next, so it is uploaded then.
    useEffect(() => {
        if (!user || !pendingGuestRecording || !localStorage.getItem("token")) {
            return;
        }

        // The user and the recording land in either order, so the blob itself is the guard.
        if (pendingGuestUploadRef.current === pendingGuestRecording) {
            return;
        }
        pendingGuestUploadRef.current = pendingGuestRecording;

        const uploadPendingGuestRecording = async () => {
            try {
                const formData = new FormData();
                formData.append('audiofile', pendingGuestRecording.blob, pendingGuestRecording.fileName);
                formData.append('timeDuration', formatTimeInHHMMSS(pendingGuestRecording.duration));
                formData.append('action', 'Audio');

                const data = await AudioHandler.doUploadAudioUrl(formData);

                if (data?.statusCode === 200) {
                    successToast(data?.message);
                    setPendingGuestRecording(null);
                    setRecordingStart(false);
                    setBtnToggl(false);
                    setIsLoginCancel(false);
                    setElapsedTime(0);
                    elapsedTimeRef.current = 0;
                    setTabIndex(2);
                    // The dashboard can already be on tab 2 with a list fetched before this upload finished, so it is told to refetch.
                    setAudioListRefreshKey((key) => key + 1);
                } else {
                    // Kept pending so the existing download flow still has the recording.
                    pendingGuestUploadRef.current = null;
                    errorToast(
                        data?.response?.data?.error ||
                        data?.response?.data?.message ||
                        data?.message ||
                        "An error occurred"
                    );
                }
            } catch (error) {
                pendingGuestUploadRef.current = null;
                errorToast(
                    error?.response?.data?.message ||
                    error?.response?.data?.error ||
                    error?.message ||
                    "An error occurred"
                );
            }
        };

        uploadPendingGuestRecording();
    }, [user, pendingGuestRecording]);

    // Jobs started in this session, plus any the backend is still running, are watched together.
    const transcribeWatchIds = Array.from(new Set([
        ...transcribeInProgressIds,
        ...[...(filterAudioData || []), ...(favoriteAudio || []), ...(folderAudioData || [])]
            .filter((item) => item?.transcribe?.status === 'processing' && !item?.transcribe?.isTranscribe)
            .map((item) => item?._id),
    ])).filter(Boolean);
    // A stable dependency, so updating a recording does not restart the poll.
    const transcribeWatchKey = transcribeWatchIds.slice().sort().join(',');

    // Announced once per recording, so a push and the poll cannot both raise the same toast.
    const announcedTranscribeIdsRef = useRef(new Set());
    // Lets a push check the status right away instead of waiting for the next poll.
    const checkTranscribeStatusRef = useRef(null);

    const announceTranscribeResult = (audioId, showToast) => {
        if (announcedTranscribeIdsRef.current.has(audioId)) {
            return;
        }

        announcedTranscribeIdsRef.current.add(audioId);
        showToast();
    };

    // The same recording sits in several lists, so all of them are rewritten with the result.
    const applyTranscribeUpdate = (audioId, updateItem) => {
        const mapList = (prev) =>
            Array.isArray(prev) ? prev.map((item) => (item?._id === audioId ? updateItem(item) : item)) : prev;

        setFilterAudioData(mapList);
        setFavoriteAudio(mapList);
        setFolderAudioData(mapList);
        setNoFolderAudioData(mapList);
        setAudio((prev) => (prev?._id === audioId ? updateItem(prev) : prev));
        setSelectedTranscriptAudio((prev) => (prev?._id === audioId ? updateItem(prev) : prev));
        setTranscribeInProgressIds((prevIds) => prevIds.filter((id) => id !== audioId));
    };

    useEffect(() => {
        const watchIds = transcribeWatchKey ? transcribeWatchKey.split(',') : [];

        if (!watchIds.length) {
            return;
        }

        let cancelled = false;
        // A finished job is announced once, even though the poll may still be in flight.
        const settledIds = new Set();

        const checkTranscribeStatus = async (audioId) => {
            if (settledIds.has(audioId)) {
                return;
            }

            try {
                const statusResponse = await AudioHandler.doHandalGetTranscriptionStatus(audioId);

                if (cancelled || settledIds.has(audioId)) {
                    return;
                }

                const transcribeStatus = statusResponse?.data?.status;

                if (transcribeStatus === 'completed') {
                    settledIds.add(audioId);
                    applyTranscribeUpdate(audioId, (item) => ({
                        ...item,
                        audio: {
                            ...item?.audio,
                            lastActionPerformed: 'Transcribe',
                        },
                        transcribe: {
                            ...item?.transcribe,
                            isTranscribe: true,
                            status: 'completed',
                            transcribeText: statusResponse?.data?.transcription,
                            summaryText: statusResponse?.data?.summary,
                            title: statusResponse?.data?.title,
                            questions: statusResponse?.data?.questions,
                        },
                    }));
                    announceTranscribeResult(audioId, () => successToast("Transcription is ready."));
                }
                else if (transcribeStatus === 'failed') {
                    settledIds.add(audioId);
                    // The job is over, so the recording can be sent again.
                    applyTranscribeUpdate(audioId, (item) => ({
                        ...item,
                        transcribe: {
                            ...item?.transcribe,
                            status: 'failed',
                        },
                    }));
                    announceTranscribeResult(audioId, () =>
                        errorToast(statusResponse?.data?.failureReason || "Transcription has failed as speech is not detected in the audio."));
                }
            } catch (error) {
                console.log(error, 'transcription status');
            }
        };

        checkTranscribeStatusRef.current = checkTranscribeStatus;

        let retryId = null;

        // The transcription runs on an outside service that never says how long it will take,
        // so the status route is asked again as soon as the previous answer is in.
        const askForStatus = async () => {
            await Promise.all(watchIds.map(checkTranscribeStatus));

            if (cancelled || settledIds.size === watchIds.length) {
                return;
            }

            retryId = setTimeout(askForStatus, 10000);
        };

        askForStatus();

        return () => {
            cancelled = true;
            checkTranscribeStatusRef.current = null;
            clearTimeout(retryId);
        };
    }, [transcribeWatchKey]);

    // Push carries a finished transcription to this browser even while the tab sits in the background.
    useEffect(() => {
        if (!localStorage.getItem("token")) {
            return;
        }

        let unsubscribe = null;

        // No prompt here: the token is only re-read when permission was already granted.
        syncExistingPushToken();

        const handlePushedTranscription = (audioId) => {
            if (!audioId) {
                return;
            }

            // The status route stays the source of truth, so the push only brings the poll forward.
            setTranscribeInProgressIds((prevIds) =>
                prevIds.includes(audioId) ? prevIds : [...prevIds, audioId]
            );
            checkTranscribeStatusRef.current?.(audioId);
        };

        onForegroundMessage((payload) => {
            if (payload?.data?.type === "transcription") {
                showBackgroundNotification(payload);
                handlePushedTranscription(payload?.data?.audioId);
            }
        }).then((off) => {
            unsubscribe = off;
        });

        // Clicking a background notification focuses this tab, so the recording is refreshed too.
        const handleWorkerMessage = (event) => {
            if (event?.data?.type === "transcription-notification-click") {
                handlePushedTranscription(event?.data?.audioId);
            }
        };

        navigator.serviceWorker?.addEventListener("message", handleWorkerMessage);

        return () => {
            if (unsubscribe) {
                unsubscribe();
            }

            navigator.serviceWorker?.removeEventListener("message", handleWorkerMessage);
        };
    }, [user]);

    return (
        <>
            <SidebarContext.Provider
                value={{
                    tabIndex,
                    setTabIndex,
                    audio,
                    setAudio,
                    selectMergeAudio,
                    setSelectMergeAudio,
                    selectedConvertAudio,
                    clickedAudios,
                    setClickedAudios,
                    setSelectedConvertAudio,
                    selectedTranscriptAudio,
                    setSelectedTranscriptAudio,
                    selectedTrimAudio,
                    setSelectedTrimAudio,
                    user,
                    setUser,
                    userAccountEmail,
                    setUserAccountEmail,
                    audioData,
                    setAudioData,
                    selectedFormat,
                    setSelectedFormat,
                    selectedQuality,
                    setSelectedQuality,
                    audioIndex,
                    setAudioIndex,
                    isAudioPlaying,
                    setIsAudioPlaying,
                    storeUser,
                    openDropdownId,
                    setOpenDropdownId,
                    audioReName, setAudioReName,
                    initialAudioName,
                    setInitialAudioName,
                    folderAudioData,
                    setFolderAudioData,
                    folderAudioIndex,
                    setFolderAudioIndex,
                    openForgotPasswordModal,
                    setOpenForgotPasswordModal,
                    openOtpModal,
                    setOpenOtpModal,
                    storeOtpUser,
                    setStoreOtpUser,
                    folderAudioDataForIndex,
                    setFolderAudioDataForIndex,
                    folders,
                    setFolders,
                    selectedAudioId,
                    setSelectedAudioId,
                    textAreaContent,
                    setTextAreaContent,
                    isUpdateTranscribe,
                    setIsUpdateTranscribe,
                    openFolderCreateModal,
                    setOpenFolderCreateModal,
                    noFolderAudioData,
                    setNoFolderAudioData,
                    initialTabIndex,
                    filterAudioData,
                    setFilterAudioData,
                    favoriteAudio,
                    setFavoriteAudio,
                    currentAudioId,
                    setCurrentAudioId,
                    selectedFolderAudioId,
                    setSelectedFolderAudioId,
                    listTabIndex,
                    setListTabIndex,
                    isFilterDropdownOpen,
                    setIsFilterDropdownOpen,
                    actionTabIndex,
                    setActionTabIndex,
                    selectedAdjustAudio, setSelectedAdjustAudio,
                    recordNew,
                    setRecordNew,
                    isPremium,
                    setIsPremium,
                    premiumLoading, setPremiumLoading,
                    premiumStatus, setPremiumStatus,
                    premiumStatusLoading,
                    setPremiumStatusLoading,
                    isPolling, setIsPolling,
                    isAnnual, setIsAnnual,
                    isProductionMode, setIsProductionMode,
                    webPlanDetails, setWebPlanDetails,
                    managePlanDetails, setManagePlanDetails,
                    isWebUser, setIsWebUser,
                    isRecordingStarted, setIsRecordingStarted,
                    isLoginCancel, setIsLoginCancel,
                    isMicrophoneAvailable, setIsMicrophoneAvailable,
                    widgetLoaded, setWidgetLoaded,
                    showModal, setShowModal,
                    modalMessage, setModalMessage,
                    actionType, setActionType,
                    pendingIndex, setPendingIndex,
                    isRecording, setIsRecording,
                    mediaRecorderRef,
                    shouldUploadRef,
                    mediaStreamRef,
                    elapsedTimeRef,
                    elapsedTime, setElapsedTime, resetRecording, intervalRef,
                    resetRecording, userReviews,
                    transcribeStartingIds, setTranscribeStartingIds,
                    transcribeInProgressIds, setTranscribeInProgressIds,
                    handoffAudioId, setHandoffAudioId,
                    autoStartRecording, setAutoStartRecording,
                    recordingFolderId, setRecordingFolderId,
                    translateSource, setTranslateSource,
                    aiToolBusy, setAiToolBusy,
                    sectionRef,
                    isSubscriptionActive, setIsSubscriptionActive,
                    recordingStart, setRecordingStart,
                    loginModalOpen, setLoginModalOpen,
                    isPaused, setIsPaused,
                    handleSaveAudioRecording,
                    btntoggl, setBtnToggl,
                    audioBlobUrl, setAudioBlobUrl,
                    pendingGuestRecording, setPendingGuestRecording,
                    audioListRefreshKey, setAudioListRefreshKey,
                    alertModal, setAlertModal,
                    stopRecording,
                    pauseRecording,
                    eventClick, setEventClick

                }}
            >
                {children}

                {
                    loginModalOpen && window.location.pathname.includes("/pricing") && (
                        <LoginModal closeModal={loginCloseModal} openModal={loginModalOpen} closePremiumModal={loginPremiumCloseModal} />
                    )
                }
            </SidebarContext.Provider>


            {/* setLoginModalOpen */}
        </>
    );


};



export default MyProvider;
